import { Grid, Skeleton, Stack, Text } from '@mantine/core'
import useGetPersonById from '@v2/domains/person/hooks/useGetPersonById.hook'

const DriverDetailsSection = ({ personId }: { personId: string }) => {
  const { modeledPerson } = useGetPersonById(personId)
  const fields = [
    { label: 'Name', value: modeledPerson?.fullName ?? '' },
    {
      label: 'TLC/DL',
      value:
        modeledPerson?.tlcLicenseNumber ??
        modeledPerson?.driversLicenseNumber ??
        '',
    },
    { label: 'Phone Number', value: modeledPerson?.formattedPhoneNumber ?? '' },
    { label: 'Email', value: modeledPerson?.email ?? '' },
  ]
  return (
    <Grid>
      {fields.map(({ label, value }) => (
        <Grid.Col key={label} span={3} mb={10}>
          <Stack align="center" ta="center">
            {modeledPerson ? (
              <>
                <Text
                  maw="100%"
                  fw={700}
                  c="var(--mantine-color-gray-6)"
                  ta="center"
                >
                  {`Driver's ${label}`}
                </Text>
                <Text style={{ wordWrap: 'break-word' }} maw="100%">
                  {value}
                </Text>
              </>
            ) : (
              <Skeleton />
            )}
          </Stack>
        </Grid.Col>
      ))}
    </Grid>
  )
}
export default DriverDetailsSection
